import React from 'react'

interface IGroupsTableView {
  onEdit: (id: string) => void;
}

const GroupsTableView = ({ onEdit }: IGroupsTableView) => {
  return (
    <div>GroupsTableView</div>
  )
}

export default GroupsTableView